import React from 'react';
import {
    MultiDropdown,
    MultiDropdownDropdownItem,
} from '@instinet-analytics/semantic-ui-components';
import {
    SymbolEventsType,
    SymbolEventsTypeValue,
} from 'widgets/corpActions/api/SymbolEventsRequest';
import { enumMapToMultiDropdownOptions } from '@instinet-analytics/core-lib';

export interface CorporateActionsTypeDropdownProps {
    selectedValues: SymbolEventsTypeValue[];
    onChange: (nextValues: SymbolEventsTypeValue[]) => void;
}

export function CorporateActionsTypeDropdown(
    props: CorporateActionsTypeDropdownProps
) {
    const { selectedValues, onChange } = props;

    const options = enumMapToMultiDropdownOptions(
        SymbolEventsType,
        true
    ) as MultiDropdownDropdownItem<string>[];

    const onDropdownChange = (value: string[]) => {
        onChange(value as SymbolEventsTypeValue[]);
    };

    return (
        <MultiDropdown
            className="CorporateActionsTypeDropdown"
            options={options}
            selectedValues={selectedValues}
            onChange={onDropdownChange}
            placeholder={'All'}
            inlineToolbar={true}
        />
    );
}
